import { render } from "./TopCustomerChart.vue?vue&type=template&id=1c4a4553&scoped=true&ts=true"
import script from "./TopCustomerChart.vue?vue&type=script&lang=ts"
export * from "./TopCustomerChart.vue?vue&type=script&lang=ts"

import "./TopCustomerChart.vue?vue&type=style&index=0&id=1c4a4553&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4a4553"]])

export default __exports__